import { useDispatch, useSelector } from 'react-redux'
import React from 'react';
import { enviarReporteProtesta } from '../features/map/mapSlice';
import { openModal } from '../features/map/modalSlice';
import { AppDispatch, RootState } from '../store';
import fpPromise from '@fingerprintjs/fingerprintjs';
import { ReportRequest } from '../types';

function ReportForm() {
    const municipios = useSelector((state: RootState) => state.map)
    const dispatch = useDispatch<AppDispatch>();
    const [deviceId, setDeviceId] = React.useState('');

    React.useEffect(() => {
        fpPromise.load() 
        .then((fp) => fp.get())
        .then((result) => {
            setDeviceId(result.visitorId); 
        })
        .catch((error) => {
            console.error("Error generating device fingerprint:", error);
        });
    }, []);
  
    const [formData, setFormData] = React.useState<ReportRequest>(
        {
            deviceId: '',
            location: '',
            mediaLink: '',
            municipioId: ''
        }
    )

    function initializeForm(){
        setFormData(
            {
                deviceId: '',
                location: '',
                mediaLink: '',
                municipioId: ''
            }
        )
    }

    function handleChange(event){
        const {name, value } = event.target

        setFormData(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }  

    async function handleSumbit(event){
        event?.preventDefault()
        
        if(!window.matchMedia("(pointer: coarse)").matches){            
            dispatch(openModal({
                title: 'Atención',
                message: 'Solo se permiten reportes desde las calles de Cuba',
                type: 'alert',
                actionId: 'ERROR_MOBILE_DEVICE'
            }))

            return;
        }        
            
        formData.deviceId = deviceId
        try {
            const res = await dispatch(enviarReporteProtesta(formData)).unwrap()
            if(!res) throw new Error();
            
            switch (res?.statusCode) {
                case 200:
                    dispatch(openModal({
                        title: 'Felicidades',
                        message: `Protesta reportada para ${municipios.items.find(m => m.id === formData.municipioId).name}.`,
                        type: 'alert',
                        actionId: 'SUCCESS'
                    }))
                    initializeForm()
                    break;
                    
                case 400:
                    if(res.message?.includes("40001202")){
                        dispatch(openModal({
                            title: 'Atención',
                            message: 'La ubicación no es válida',
                            type: 'alert',
                            actionId: 'API_ERROR'
                        }))
                        break;
                    }
                    if(res.message?.includes("40001203")){
                        dispatch(openModal({
                            title: 'Atención',
                            message: 'Usted ya ha reportado una protesta',
                            type: 'alert',
                            actionId: 'HACK_ERROR'
                        }))
                        break;
                    }
                    if(res.message?.includes("40001206")){
                        throw new Error();
                    }
                    if(res.message?.includes("40001201")){
                        throw new Error();
                    }
                    if(res.message?.includes("40001204")){
                        dispatch(openModal({
                            title: 'Atención',
                            message: 'Solo se permiten reportes desde las calles de Cuba',
                            type: 'alert',
                            actionId: 'HACK_ERROR'
                        }))
                        break;
                    }
                    if(res.message?.includes("40001205")){
                        dispatch(openModal({
                            title: 'Atención',
                            message: 'Solo se permiten reportes desde las calles de Cuba',
                            type: 'alert',
                            actionId: 'HACK_ERROR'
                        }))
                        break;
                    }

                    res.errors?.map(e => {
                        if(e.includes("Location")){
                            dispatch(openModal({
                                title: 'Atención',
                                message: 'La ubicación no es válida',
                                type: 'alert',
                                actionId: 'DTO_ERROR'
                            }))
                        }
                        else if(e.includes("MunicipioId")){
                            dispatch(openModal({
                                title: 'Atención',
                                message: 'Debe seleccionar el Municipio',
                                type: 'alert',
                                actionId: 'DTO_ERROR'
                            }))
                        }
                        else if(e.includes("Media Link")){
                            dispatch(openModal({
                                title: 'Atención',
                                message: 'El enlace de las Imágenes no es válido',
                                type: 'alert',
                                actionId: 'DTO_ERROR'
                            }))
                        }
                    })
                    break;
                    
                default:
                    throw new Error();
            }
            
        } catch (error) {
            dispatch(openModal({
                title: 'Atención',
                message: 'Error enviando reporte.',
                type: 'alert',
                actionId: 'API_ERROR'
            }))          
        }        
    }

    return (
        <div className='report-container'>
            <header>Reportar Protesta</header>
            <div>                
                <form onSubmit={handleSumbit}>
                    <div className='form-group'>
                        <label htmlFor="municipioId">Municipio</label>
                        <select 
                            id="municipioId"
                            value={formData.municipioId}
                            onChange={handleChange}
                            name="municipioId"
                            >
                            <option value=""></option>
                            {
                                municipios.items.map((item) =>(
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))
                            }
                            
                        </select>
                    </div>
                    <div className='form-group'>
                        <label htmlFor="location">Ubicación</label>
                        <input 
                            className='report-input'
                            type="text"
                            placeholder="Escribir ubicación"
                            onChange={handleChange}
                            name="location"
                            value={formData.location}
                        />
                    </div>
                    <div className='form-group'>
                        <label htmlFor="mediaLink">Enlace de las imágenes <i>(Opcional)</i></label>
                        <input 
                            className='report-input'
                            type="text"
                            placeholder="Pegar enlace de las imágenes"
                            onChange={handleChange}
                            name="mediaLink"
                            value={formData.mediaLink}
                        />
                    </div>
                    <button>Enviar</button>
                </form>  
            </div>
        </div>
    )
}

export default ReportForm